var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5848",
    "data-name": "Group 5848",
    transform: "translate(-2030 -1689)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(2030 1689)",
    fill: "#3D7CC9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "xls-file",
    d: "M63.518,0H50.13a3.553,3.553,0,0,0-3.548,3.548V16.667h-.347a1.429,1.429,0,0,0-1.43,1.43v8.67a1.429,1.429,0,0,0,1.43,1.43h.347v1.59a3.552,3.552,0,0,0,3.548,3.548H68.4a3.551,3.551,0,0,0,3.547-3.548V8.4ZM48.445,19.581h1.561l.526,1.1c.179.365.313.66.455,1h.017c.143-.383.259-.652.411-1l.508-1.1h1.552l-1.695,2.934,1.784,3.078H52l-.544-1.089c-.223-.42-.366-.731-.536-1.08H50.9c-.125.349-.277.66-.464,1.08l-.5,1.089H48.383l1.74-3.042ZM68.4,31.161H50.13a1.376,1.376,0,0,1-1.374-1.375V28.2H65.785a1.429,1.429,0,0,0,1.43-1.43V18.1a1.429,1.429,0,0,0-1.43-1.43H48.756V3.548A1.376,1.376,0,0,1,50.13,2.175l12.575-.013V6.81a2.461,2.461,0,0,0,2.46,2.46l4.554-.013.051,20.528A1.375,1.375,0,0,1,68.4,31.161ZM58.056,24.452v1.142H54.3V19.581h1.365v4.871Zm2.3-1.383c-1-.348-1.651-.9-1.651-1.775,0-1.027.856-1.811,2.275-1.811a3.692,3.692,0,0,1,1.535.3l-.3,1.1a2.864,2.864,0,0,0-1.258-.286c-.589,0-.874.268-.874.58,0,.383.339.554,1.115.848,1.062.392,1.561.946,1.561,1.794,0,1.008-.776,1.864-2.427,1.864a3.932,3.932,0,0,1-1.7-.366l.277-1.123a3.466,3.466,0,0,0,1.507.374c.624,0,.955-.258.955-.651C61.368,23.542,61.083,23.327,60.36,23.069Z",
    transform: "translate(2001.194 1702.333)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXls);
export default __webpack_public_path__ + "static/media/icon-xls.e7f21331c27d05be86cbd637cf57c3d8.svg";
export { ForwardRef as ReactComponent };